export function formatPhoneNumber(phoneNumberString: string) {
    const phoneNumberWithoutHyphen = phoneNumberString.replace(/^[+\D].*\D/g, '');
    return phoneNumberWithoutHyphen;
}
